module.exports = "/assets/schneider-iem3455-electricity-meter.png";